import { TriangleAlertFillIcon } from 'components/icons/TriangleAlertFill'
import classNames from 'classnames'

export function WarningBox({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={classNames(
        'relative rounded-lg bg-[#F356421A] px-3 py-2',
        className
      )}
    >
      <div className="pointer-events-none absolute inset-0 rounded-lg border border-core-error" />
      <div className="flex items-center gap-2">
        <TriangleAlertFillIcon size={24} className="shrink-0 text-core-error" />
        <div className="flex flex-col text-body-medium text-core-error">
          {children}
        </div>
      </div>
    </div>
  )
}
